/**
 * Spinner - Shared loading spinner with size variants
 */

import React from 'react';

const SIZE_CLASSES = {
  sm: 'h-5 w-5 border',
  md: 'h-8 w-8 border-2',
  lg: 'h-12 w-12 border-2',
};

const Spinner = ({ size = 'md' }) => {
  const sizeClass = SIZE_CLASSES[size] || SIZE_CLASSES.md;

  return (
    <div className="flex items-center justify-center py-20">
      <div className={`animate-spin ${sizeClass} border-primary-600 border-t-transparent rounded-full`} />
    </div>
  );
};

export default React.memo(Spinner);
